(function () {
  // Inject styles
  const style = document.createElement('style');
  style.innerHTML = `
  #dripp-accessibility-wrapper {
    position: fixed;
    bottom: 20px;
    left: 20px;
    z-index: 9999;
  }

  #dripp-accessibility-fab {
    background: #000;
    color: #fff;
    border: none;
    width: 46px;
    height: 46px;
    border-radius: 50%;
    cursor: pointer;
    box-shadow: 0 0 10px rgba(0,0,0,0.2);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
  }

  #dripp-accessibility-fab svg {
    width: 20px;
    height: 20px;
    fill: white;
  }

  #dripp-accessibility-panel {
    background: #fff;
    border-radius: 10px;
    box-shadow: 0 0 10px rgba(0,0,0,0.15);
    padding: 12px;
    width: 260px;
    position: absolute;
    bottom: 70px;
    left: 0;
    transform: translateY(100%);
    opacity: 0;
    transition: all 0.3s ease;
    pointer-events: none;
    font-family: inherit;
  }

  #dripp-accessibility-wrapper.active #dripp-accessibility-panel {
    transform: translateY(0%);
    opacity: 1;
    pointer-events: auto;
  }

  #dripp-accessibility-panel h4 {
    margin: 0 0 10px;
    font-size: 16px;
  }

  .dripp-accessibility-group {
    margin-bottom: 12px;
  }

  #dripp-accessibility-panel button {
    display: block;
    width: 100%;
    margin: 4px 0;
    padding: 2px 8px;
    font-size: 14px;
    border: 1px solid #ddd;
    background: #f9f9f9;
    cursor: pointer;
    border-radius: 4px;
    text-align: left;
  }

  #dripp-accessibility-panel button:hover {
    background: #efefef;
  }

  .dripp-accessibility-controls {
    position: absolute;
    top: 8px;
    right: 8px;
    display: flex;
    gap: 6px;
  }

  .dripp-accessibility-controls button {
    width: 26px;
    height: 26px;
    padding: 0;
    border: none;
    border-radius: 50%;
    background: #eee;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .dripp-accessibility-controls button:hover {
    background: #ddd;
  }

  .dripp-accessibility-controls svg {
    width: 14px;
    height: 14px;
    fill: #333;
  }

  /* Accessibility Styles */
  .dripp-invert      { filter: invert(1) hue-rotate(180deg) !important; }
  .dripp-dark        { filter: brightness(0.8) contrast(1.5) !important; }
  .dripp-light       { filter: brightness(1.2) contrast(1.1) !important; }
  .dripp-saturate    { filter: saturate(2) !important; }
  .dripp-desaturate  { filter: saturate(0.3) !important; }
  .dripp-grayscale   { filter: grayscale(1) !important; }

  .dripp-bigger-text * {
    font-size: 110% !important;
  }

  .dripp-readable-fonts * {
    font-family: Arial, sans-serif !important;
  }

  .dripp-highlight-titles h1,
  .dripp-highlight-titles h2,
  .dripp-highlight-titles h3 {
    background: yellow;
  }

  .dripp-highlight-links a {
    background: lightblue;
    text-decoration: underline !important;
  }

  .dripp-stop-animation * {
  animation: none !important;
  transition: none !important;
}

  `;
  document.head.appendChild(style);

  // Wrapper + HTML
  const wrapper = document.createElement('div');
  wrapper.id = 'dripp-accessibility-wrapper';
  wrapper.innerHTML = `
    <button id="dripp-accessibility-fab"><i class="fas fa-binoculars"></i></button>


    <div id="dripp-accessibility-panel">
      <div class="dripp-accessibility-controls">
        <button id="dripp-reset-btn" title="Reset">
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
      <path d="M12 5v2a5 5 0 1 1-5 5H5a7 7 0 1 0 7-7z"/>
      <path d="M13 2v4h-4"/>
    </svg>
  </button>
        <button id="dripp-close-btn" title="Close">
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
      <path d="M6 6l12 12M18 6L6 18"/>
    </svg>
  </button>

      </div>

      <h4>Accessibility Settings</h4>

      <div class="dripp-accessibility-group">
        <strong>Color Adjustments</strong>
        <button data-action="invert">Invert Colors</button>
        <button data-action="dark">Dark Contrast</button>
        <button data-action="light">Light Contrast</button>
        <button data-action="saturate">High Saturation</button>
        <button data-action="desaturate">Low Saturation</button>
        <button data-action="grayscale">Desaturate</button>
      </div>

      <div class="dripp-accessibility-group">
        <strong>Content Adjustments</strong>
        <button data-action="bigger-text">Bigger Text</button>
        <button data-action="readable-fonts">Readable Fonts</button>
        <button data-action="highlight-titles">Highlight Titles</button>
        <button data-action="highlight-links">Highlight Links</button>
      </div>

      <div class="dripp-accessibility-group">
        <strong>Other</strong>
        <button data-action="stop-animation">Stop Animation</button>
      </div>
    </div>
  `;
  document.body.appendChild(wrapper);

  const fab = wrapper.querySelector('#dripp-accessibility-fab');
  const panel = wrapper.querySelector('#dripp-accessibility-panel');
  const buttons = panel.querySelectorAll('button[data-action]');
  const html = document.documentElement;

  // Toggle panel
  fab.addEventListener('click', () => {
    wrapper.classList.toggle('active');
  });

  // Close panel
  wrapper.querySelector('#dripp-close-btn').addEventListener('click', () => {
    wrapper.classList.remove('active');
  });

  // Reset all
  wrapper.querySelector('#dripp-reset-btn').addEventListener('click', () => {
    const allClasses = [
      'dripp-invert', 'dripp-dark', 'dripp-light',
      'dripp-saturate', 'dripp-desaturate', 'dripp-grayscale',
      'dripp-bigger-text', 'dripp-readable-fonts',
      'dripp-highlight-titles', 'dripp-highlight-links'
    ];
    allClasses.forEach(cls => html.classList.remove(cls));
    localStorage.removeItem('dripp-accessibility');
  });

  // Feature toggles
  buttons.forEach(btn => {
    btn.addEventListener('click', () => {
      const action = `dripp-${btn.dataset.action}`;
      html.classList.toggle(action);

      // Save to localStorage
      const current = JSON.parse(localStorage.getItem('dripp-accessibility') || '[]');
      if (html.classList.contains(action)) {
        current.push(action);
      } else {
        const idx = current.indexOf(action);
        if (idx !== -1) current.splice(idx, 1);
      }
      localStorage.setItem('dripp-accessibility', JSON.stringify([...new Set(current)]));
    });
  });

  // Restore state
  const saved = JSON.parse(localStorage.getItem('dripp-accessibility') || '[]');
  saved.forEach(cls => html.classList.add(cls));
})();